const draftKey = (taskId, stepId) => `icbt-survey-draft-${taskId}-${stepId}`;

export function readSurveyDraft(taskId, stepId) {
  try {
    return JSON.parse(sessionStorage.getItem(draftKey(taskId, stepId))) || {};
  } catch (error) {
    return {};
  }
}

export function saveSurveyDraft(taskId, stepId, questions, currentIndex) {
  try {
    const answers = Object.fromEntries(questions.map(item => [item.code, item.selectVal]));
    sessionStorage.setItem(draftKey(taskId, stepId), JSON.stringify({ answers, currentIndex }));
  } catch (error) {
    // Storage can be unavailable in private browsing; filling must still work.
  }
}

export function clearSurveyDraft(taskId, stepId) {
  try {
    sessionStorage.removeItem(draftKey(taskId, stepId));
  } catch (error) {
    // Do not turn a successful submission into an error if storage is blocked.
  }
}
